import React from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { AddEdit as AddEditInterface } from "../../../../interfaces/transaction.interface";
import { Modules, RouteParamsTypes } from "../../../../enums";

interface FormHeaderProps {
  formData: AddEditInterface;
  id: string;
  view: boolean;
  external?: boolean;
}

const FormHeader: React.FC<FormHeaderProps> = ({ formData, id, view, external }) => {
  const { t } = useTranslation();

  const handleInvoiceClick = (id: string) => {
    window.open(`${Modules.invoices}${RouteParamsTypes.view}/${id}`, '_blank');
  }

  const handleStatementClick = (id: number) => {
    window.open(`${Modules.reconciliation}${RouteParamsTypes.managerStatement}/${id}`, '_blank');
  }

  const segments: React.ReactNode[] = [
    t("transactions.addEdit.pageTexts.title.invoiceStatus", { status: formData.statusLabel }),
  ];

  if (formData.invoiceNo) {
    segments.push(
      <span className={clsx(!external && 'cursor-pointer text-decoration-underline hyperlink')} onClick={() => !external && handleInvoiceClick(formData.invoiceId)}>
        {t("transactions.addEdit.pageTexts.title.invoiceNo", { invoiceNumber: formData.invoiceNo })}
      </span>
    );
  }

  segments.push(
    t("transactions.addEdit.pageTexts.title.statementStatus", { status: formData.statementStatusLabel || '-' })
  );

  if (formData.managerStatement) {
    segments.push(
      <span className={clsx(!external && 'cursor-pointer text-decoration-underline hyperlink')} onClick={() => !external && handleStatementClick(formData.managerStatement!.id)}>
        {t("transactions.addEdit.pageTexts.title.statementNumber", { statementNumber: formData.managerStatement.statementNumber })}
      </span>
    );
  }

  return (
    <div className="d-flex justify-content-between">
      <h5 className={clsx("card-header", external && 'fs-4')}>{!id ? t("transactions.addEdit.pageTexts.title.addTitle") : (view ? t("transactions.addEdit.pageTexts.title.viewTitle") : t("transactions.addEdit.pageTexts.title.editTitle"))}</h5>

      <div className={clsx("d-flex align-items-center flex-wrap text-primary fw-bold", !external && "p-5", external && "fs-6")}>
        {segments.map((segment, index) => (
          <React.Fragment key={index}>
            {index > 0 && <span className="mx-2">|</span>}
            {segment}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default FormHeader;